import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotSection from './components/HotSection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  'name': '韩漫漫画网 - 最新高清免费韩国漫画大全',
  'description': '韩漫漫画网提供最新高清免费韩国漫画大全，韩漫网热门韩漫在线观看，画面精美，更新及时，随时随地满足您的观漫需求。',
  'url': 'https://www.hanmancomic.com/',
  'potentialAction': {
    '@type': 'SearchAction',
    'target': 'https://www.hanmancomic.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  useEffect(() => {
    document.title = '韩漫漫画网-最新高清免费韩国漫画大全_韩漫网热门韩漫在线观看';
  }, []);

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(homepageSchema)}
      </script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategoryNav />
          <HotSection />
          <FeaturedSection />
          <LatestSection />
        </main>
        <Footer />
      </div>
    </>
  );
}